import { render, staticRenderFns } from "./OtherMaterials.vue?vue&type=template&id=7bb0bdb6&scoped=true&"
import script from "./OtherMaterials.vue?vue&type=script&lang=js&"
export * from "./OtherMaterials.vue?vue&type=script&lang=js&"
import style0 from "./OtherMaterials.vue?vue&type=style&index=0&id=7bb0bdb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb0bdb6",
  null
  
)

export default component.exports